import { render, staticRenderFns } from "./PostCertificate.vue?vue&type=template&id=25e1ccaa&scoped=true&"
import script from "./PostCertificate.vue?vue&type=script&lang=js&"
export * from "./PostCertificate.vue?vue&type=script&lang=js&"
import style0 from "./PostCertificate.vue?vue&type=style&index=0&id=25e1ccaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e1ccaa",
  null
  
)

export default component.exports